"use client";
import Link from "next/link";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-center text-6xl font-extrabold text-orange-600">
            404
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Oops! The page you're looking for was not found.
          </p>
        </div>
        <div className="mt-5">
          <Link
            href="/"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <ArrowLeft className="h-5 w-5 text-orange-500 group-hover:text-orange-400" aria-hidden="true" />
            </span>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
